
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-02-12-draggable-objects",
      function () {
        return require("private-next-pages/blogs/2024-02-12-draggable-objects/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-02-12-draggable-objects"])
      });
    }
  